module.exports = __webpack_public_path__ + "img/证书5.3b19c54f.jpg";